// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__h7Otu","errors":"Errors_errors__18VkW"};